import React, { useState } from 'react'

const faqData = [
  {
    question: "Che tipo di essenze utilizzate per gli allestimenti?",
    answer: "Mi specializzo in essenze decorative e scenografiche come aceri, ortensie, camelie e piante perenni. Ogni selezione è pensata per creare atmosfere uniche e naturali, adatte al settore dell'ospitalità e al tipo di ambiente del tuo locale."
  },
  {
    question: "Come funziona la manutenzione degli allestimenti?",
    answer: "Offro un servizio di manutenzione completo e regolare per garantire che le piante rimangano sempre in perfette condizioni. Questo include potature, concimazioni, irrigazione e sostituzione quando necessario, tutto incluso nel servizio."
  },
  {
    question: "Quanto tempo richiede la realizzazione di un progetto?",
    answer: "I tempi variano in base alla complessità dell'allestimento. Dopo il sopralluogo iniziale, fornisco un cronoprogramma dettagliato. Generalmente, progetti standard richiedono 1-2 settimane, mentre allestimenti più elaborati possono richiedere più tempo."
  },
  {
    question: "Lavorate anche con locali già esistenti o solo nuove aperture?",
    answer: "Lavoro sia con nuove aperture che con locali già esistenti che desiderano rinnovare o migliorare i propri spazi. Ogni progetto è personalizzato per integrarsi perfettamente con l'arredamento e lo stile esistente del locale."
  }
]

const AccordionItem = ({ item, isOpen, onClick }) => {
  return (
    <div className="border-b border-brand-green/10">
      <button
        className="w-full flex justify-between items-center text-left py-6"
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <h3 className="text-xl font-medium text-brand-green">{item.question}</h3>
        <span className={`transform transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : ''}`}>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand-green" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </span>
      </button>
      <div className={`grid transition-all duration-500 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
        <div className="overflow-hidden">
          <p className="pb-6 pr-8 text-brand-text/70 leading-relaxed">{item.answer}</p>
        </div>
      </div>
    </div>
  )
}

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0)

  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <section id="faq" className="py-24 bg-brand-subtle-bg scroll-mt-24">
      <div className="container mx-auto px-6 max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Domande Frequenti</h2>
          <p className="text-lg text-brand-text/70">Trova qui le risposte ai dubbi più comuni. Per qualsiasi altra domanda, non esitare a contattarci.</p>
        </div>
        
        <div className="bg-white p-4 sm:p-8 rounded-lg shadow-sm border border-gray-200/80">
          {faqData.map((item, index) => (
            <AccordionItem
              key={index}
              item={item}
              isOpen={openIndex === index}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default FAQ